import { render, staticRenderFns } from "./CentroConvencoes.vue?vue&type=template&id=e16ada70&scoped=true&"
import script from "./CentroConvencoes.vue?vue&type=script&lang=js&"
export * from "./CentroConvencoes.vue?vue&type=script&lang=js&"
import style0 from "./CentroConvencoes.vue?vue&type=style&index=0&id=e16ada70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e16ada70",
  null
  
)

export default component.exports